
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1608443191173",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "7699",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M974.592 42.944C965.76 35.776 954.944 32 944 32c-7.296 0-14.656 1.664-21.44 5.056l-864 432C43.392 476.672 33.344 491.712 32.128 508.608c-1.216 16.896 6.656 33.216 20.544 42.88l219.456 151.872c0 0.256-0.128 0.448-0.128 0.64l0 240c0 20.8 13.44 39.232 33.28 45.696C310.144 991.232 315.136 992 320 992c15.104 0 29.76-7.104 38.912-19.904l100.416-139.136 217.344 150.528C684.8 989.12 694.4 992 704 992c5.504 0 11.072-0.96 16.384-2.88 14.592-5.248 25.728-17.344 29.888-32.256l240-864C995.392 74.56 989.184 54.976 974.592 42.944zM295.168 660.992 80 512l728.256-364.096L295.168 660.992zM320 944 320 704l624-624L320 944zM704 944l-216.512-149.888 419.52-580.864L704 944z",
        "p-id": "7700"
      }
    }
  ]
})
    }
  